import { render, staticRenderFns } from "./ClientsPages.vue?vue&type=template&id=fa559924&scoped=true"
import script from "./ClientsPages.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsPages.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ClientsPages.vue?vue&type=style&index=0&id=fa559924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa559924",
  null
  
)

export default component.exports